module.exports = ".item-wrapper {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #fff; }\n  .item-wrapper i {\n    margin: 0px 10px 0px 10px;\n    color: rgba(4, 15, 160, 0.8);\n    font-size: 20px; }\n  .item-wrapper:hover {\n    background-color: #f7f7f7; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/exportar/itemExportacao/item-exportacao.component.scss
// module id = ./src/app/components/exportar/itemExportacao/item-exportacao.component.scss
// module chunks = main